/* tslint:disable */
/* eslint-disable */
/**
 * COTATO 프로젝트 API 명세서
 * api 명세서
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CotatoMemberInfoResponseRoleEnum = {
    Member: 'MEMBER',
    Manager: 'MANAGER',
    Admin: 'ADMIN',
    Dev: 'DEV'
};
/**
 * @export
 */
export const CotatoMemberInfoResponseStatusEnum = {
    Inactive: 'INACTIVE',
    Rejected: 'REJECTED',
    Requested: 'REQUESTED',
    Retired: 'RETIRED',
    Approved: 'APPROVED'
};
/**
 * @export
 */
export const CotatoMemberInfoResponsePositionEnum = {
    None: 'NONE',
    Be: 'BE',
    Fe: 'FE',
    Design: 'DESIGN',
    Pm: 'PM'
};
/**
 * Check if a given object implements the CotatoMemberInfoResponse interface.
 */
export function instanceOfCotatoMemberInfoResponse(value) {
    if (!('memberId' in value) || value['memberId'] === undefined)
        return false;
    return true;
}
export function CotatoMemberInfoResponseFromJSON(json) {
    return CotatoMemberInfoResponseFromJSONTyped(json, false);
}
export function CotatoMemberInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'memberId': json['memberId'],
        'name': json['name'] == null ? undefined : json['name'],
        'backFourNumber': json['backFourNumber'] == null ? undefined : json['backFourNumber'],
        'role': json['role'] == null ? undefined : json['role'],
        'status': json['status'] == null ? undefined : json['status'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}
export function CotatoMemberInfoResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'memberId': value['memberId'],
        'name': value['name'],
        'backFourNumber': value['backFourNumber'],
        'role': value['role'],
        'status': value['status'],
        'position': value['position'],
    };
}
